import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getSurveyTemplates } from './api';
import type { SurveyTemplatesResult } from './SurveyTemplate';

const SURVEY_TEMPLATES_BASE_KEY = 'survey_templates';

export const useSurveyTemplatesQuery = (): UseQueryResult<SurveyTemplatesResult, Error> => {
  return useQuery([SURVEY_TEMPLATES_BASE_KEY], () => getSurveyTemplates(), {
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
